<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
                "ydtBillCode":"20180101101021224433",
                "outerRefundCode":"2018010110102122122",
                "refundValue":5.00,
                "refundDesc":"预定退款"

           },
            responseCode: {"data":{
                "ydtRefundCode":"2018010110102123112"
            },"message":"业务成功","resultCode":0,"status":1}	,
            infoData: {
                explain: "退款接口",
                t_url: this.commonUrls.test+"refundOrder",
                p_url: this.commonUrls.prod+"refundOrder",
                precondition: "无",

                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'ydtBillCode', info2: '二选一', info3: 'String', info4: '智慧停车支付流水号' },
                        { info1: 'outerBillCode', info2: '二选一', info3: 'String', info4: '第三方支付流水号' },
                        { info1: 'outerRefundCode', info2: '是', info3: 'String', info4: '第三方退款流水号' },
                        { info1: 'refundValue', info2: '是', info3: 'decimal', info4: '退款金额' },
                        { info1: 'refundDesc', info2: '是', info3: 'String', info4: '退款说明' },
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'ydtRefundCode', info2: '是', info3: 'String', info4: '智慧停车退款流水号' }
                        ]
                }]
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/deprecated/ydtPay/refundOrder.vue